import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output} from '@angular/core';
import {Input} from "@angular/core";
import {ViewService} from "../../../services/common/view.service";


type Layout =
  "car" |
  "carDetailHead" |
  "carSimple" |

  "poi" |
  "poiDetailHead" |
  // mobile pages
  "poiDetailHead-mobile_alarmPoiPage" |
  "poiDetailHead-mobile_usersPage";

// type Status =
//   "off" |
//   "on";


@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemComponent implements OnInit {


  // component args

  // additional css classes
  @Input() css: string;
  @Input() layout: Layout/*  = "car" */;
  @Input() obj;
  // avatar border
  @Input() selected: boolean;
  @Input() status: boolean;
  @Input() visibleOnMap: boolean;

  // desktop extras
  @Input() labelDay: string;
  @Input() hideAddress: boolean;


  // checkbox
  @Input() checkboxValue: boolean;
  @Input() showCheckbox: boolean;


  @Output() select = new EventEmitter<any>();
  @Output() toggleCheckbox = new EventEmitter<any>();



  // listener

  listener = {
    view: null,
  };



  constructor(
    private cd: ChangeDetectorRef,
    public view: ViewService,
  ) {}



  ngOnInit() {
    this.listenerView();
  }


  ngOnDestroy() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }





  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }









}
